import { qs } from './utils'
import { Sniffer } from './utils/Sniffer'

const store = {
  title: 'Tsunami',
  author: {
    name: 'Non-Linear',
    link: 'https://www.non-linear.studio/',
  },
    
  body: document.body,

  bounds: {
    ww: window.innerWidth,
    wh: Sniffer.isDevice ? window.outerHeight : window.innerHeight,
  }, 
  
  flags: {
    isScrolling: false,
    locked: false,
    smooth: true,    
  },  
  
  sniffer: Sniffer,

  benchmark: null,

  progress: [
    { value: 0 },
    { value: 0 },
    { value: 0 },
    { value: 0 },
    { value: 0 },
    { value: 0 },
    { value: 0 },
    { value: 0 },
    { value: 0 },
  ],  
}

export default store